import { ProductOrganisationId, ProductOrganisationInvoicing } from './../../../../../models/src/lib/products/product-organisation';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Inject, resolveForwardRef } from '@angular/core';
import { API_SERVER_TOKEN } from '../api-server-token';
import { ProductOrganisationProfile, ProductOrgPricingProfile, ProductOrgProfile, ProfileId } from '@portal-front-end/models';
import { profile } from 'console';

@Injectable({ providedIn: 'root' })

export class ProductsOrgProfilesApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PROD_ORG_PROF_URL = `${this.apiServer}/product-organisations-profiles`;
    private readonly PROD_ORG_PROF_HOST_URL = `${this.apiServer}/product-organisations-profile-host-flags`;

    getAllProductProfiles(productOrganisationId: string): Observable<ProductOrganisationProfile[]> {
        return this.http.get<ProductOrganisationProfile[]>(`${this.PROD_ORG_PROF_URL}`,
            { 'params': { 'productOrganisationId': productOrganisationId } }
        );
    }
    addProductProfiles(data: ProductOrgPricingProfile): Observable<ProductOrgPricingProfile> {
        return this.http.post<ProductOrgPricingProfile>(`${this.PROD_ORG_PROF_URL}`, data);
    }
    getProductOrgProfileByProfileId(profileId: ProfileId): Observable<ProductOrganisationProfile[]> {
        return this.http.get<ProductOrganisationProfile[]>(`${this.PROD_ORG_PROF_URL}/profile/${profileId}`);
    }

    updateProfile(profileData: ProductOrganisationProfile) {
        return this.http.put(`${this.PROD_ORG_PROF_URL}/${profileData.productOrganisationId}/${profileData.profileId}`, profileData);
    }

    getProductProfilesByProductorgId(productOrganisationId: ProductOrganisationId) {
        return this.http.get<ProductOrganisationProfile[]>(`${this.PROD_ORG_PROF_URL}/product-organisation/${productOrganisationId}`);
    }

    getProductOrganisationForInvocing(requestParams): Observable<ProductOrganisationInvoicing[]> {
        return this.http.get<ProductOrganisationInvoicing[]>(`${this.PROD_ORG_PROF_URL}/detailed-search`, {
            params: requestParams
        });
    }

    deleteProductOriganisationProfile(productOrganisationProfileId: number): Observable<string | number> {
        return this.http.delete<string | number>(`${this.PROD_ORG_PROF_URL}/${productOrganisationProfileId}`);
    }

    reactivateProductOrganisationProfile(productOrganisationProfileId: number) {
        return this.http.post(`${this.PROD_ORG_PROF_URL}/reactivate/${productOrganisationProfileId}`, null);
    }

    addProductOrganisationProfileToHost(hostId: string, productOrganisationProfileId: string[]): Observable<ProductOrgProfile[]> {
        return this.http.post<ProductOrgProfile[]>(`${this.PROD_ORG_PROF_HOST_URL}/refresh-host`,
            {
                "hostId": hostId,
                "productOrganisationProfileIds": productOrganisationProfileId

            }
        );
    }
    downloadProductOrganisationProfile(productOrganisationId: string, ProfileId: string): Observable<HttpResponse<Blob>> {
        return this.http.get<Blob>(`${this.PROD_ORG_PROF_URL}/export`, {
            params: {
                'organisationId': productOrganisationId,
                'profileId': ProfileId
            },
            responseType: 'blob' as 'json',
            observe: 'response'
        });
    }
    approveProfilePrice(profilePriceIds: number[]): Observable<string> {
        return this.http.put<string>(`${this.PROD_ORG_PROF_URL}/bulk-update-status`, {
            statusId: 1,
            productOrganisationProfileIdList: profilePriceIds
        });
    }
    resendProductOrganisationProfile( productOrganisationProfileId: number[]): Observable<ProductOrgProfile[]> {
        return this.http.post<ProductOrgProfile[]>(`${this.PROD_ORG_PROF_HOST_URL}`,
            {
                "productOrganisationProfileIds": productOrganisationProfileId
            }
        );
    }
}
